import { useMemo } from 'react';
import { usePreferenceStore } from '@/app/store/preferenceStore';
import { getAccountIdsForSite } from '@/app/config/accountFilters';

export interface UseAccountFiltersReturn {
  paymentAccountIds: number[];
  expenseAccountIds: number[];
}

/**
 * Custom hook to get filtered account IDs based on user's default site
 * @returns Object containing arrays of account IDs for different contexts
 */
export function useAccountFilters(): UseAccountFiltersReturn {
  const defaultSiteId = usePreferenceStore((state) => state.defaultSiteId);

  const paymentAccountIds = useMemo(
    () => getAccountIdsForSite(defaultSiteId, 'payment'),
    [defaultSiteId]
  );

  const expenseAccountIds = useMemo(
    () => getAccountIdsForSite(defaultSiteId, 'expense'),
    [defaultSiteId]
  );

  return {
    paymentAccountIds,
    expenseAccountIds,
  };
}